// extracted by mini-css-extract-plugin
export default {"loadingButton":"styles_loadingButton__lV-LH"};